import { render, staticRenderFns } from "./AttendanceRequestContextMenu.vue?vue&type=template&id=a21d370c&scoped=true"
import script from "./AttendanceRequestContextMenu.vue?vue&type=script&lang=js"
export * from "./AttendanceRequestContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d370c",
  null
  
)

export default component.exports